export default "__VITE_ASSET__Xzky$_rb__"